
import Vue from "vue";

const state = {
    EquipmentDailyItems: {
        equipments: [],
        calendarJobs: {},
        equipmentTotal: 0
    },
    EquipmentWeeklyItems: {
        equipments: [],
        calendarJobs: {},
        equipmentTotal: 0
    },
    EquipmentMonthlyItems: {
        equipments: [],
        calendarJobs: {},
        equipmentTotal: 0
    },
    PropertyDailyItems: {
        properties: [],
        calendarJobs: {},
        propertiesTotal: 0
    },
    PropertyWeeklyItems: {
        properties: [],
        calendarJobs: {},
        propertiesTotal: 0
    },
    PropertyMonthlyItems: {
        properties: [],
        calendarJobs: {},
        propertiesTotal: 0
    },

    equipmentStructureType: {},
    locationInfo: {},
    maintProgram: {},
    year: 0,
}

const getters = {
    EquipmentDailyItems: (state) => state.EquipmentDailyItems,
    EquipmentDailyTotalRows: (state) => state.EquipmentDailyItems.equipmentTotal,
    EquipmentWeeklyItems: (state) => state.EquipmentWeeklyItems,
    EquipmentWeeklyTotalRows: (state) => state.EquipmentWeeklyItems.equipmentTotal,
    EquipmentMonthlyItems: (state) => state.EquipmentMonthlyItems,
    EquipmentMonthlyTotalRows: (state) => state.EquipmentMonthlyItems.equipmentTotal,
    PropertyDailyItems: (state) => state.PropertyDailyItems,
    PropertyDailyTotalRows: (state) => state.PropertyDailyItems.propertiesTotal,
    PropertyWeeklyItems: (state) => state.PropertyWeeklyItems,
    PropertyWeeklyTotalRows: (state) => state.PropertyWeeklyItems.propertiesTotal,
    PropertyMonthlyItems: (state) => state.PropertyMonthlyItems,
    PropertyMonthlyTotalRows: (state) => state.PropertyMonthlyItems.propertiesTotal,
    EquipmentStructureType: (state) => state.equipmentStructureType,
    LocationInfo: (state) => state.locationInfo,
    MaintProgram: (state) => state.maintProgram,
    Year: (state) => state.year,
}

const actions = {
    /* Equipment */
    async getEquipmentDailyItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/runsheet-calendar/equipment`, { params: params })
                .then(response => {
                    var result = {};
                    var data = response.data.data;
                    result.equipments = data.equipmentItems;
                    result.equipmentTotal = data.equipmentTotal;
                    commit('setEquipmentDailyItems',result);                    
                    commit('clearEquipmentDailyCalendarJobs', null);
                    data.equipmentItems.forEach(function(eqm){
                        if(!Array.isArray(data.jobItems)){
                            var eqmDates = data.jobItems[eqm.id];
                            var key = eqm.id;
                            var calendarDays = {};
                            if(eqmDates){                                    
                                Object.keys(eqmDates).forEach(function(key){
                                    var eqmDate = eqmDates[key];       
                                    if(eqmDate.length == 1){
                                        calendarDays[eqmDate[0].planned_date]={type: "Single",item:eqmDate[0]};
                                    }
                                    else{
                                        calendarDays[eqmDate[0].planned_date]={type: "Overlap",item:eqmDate};
                                    }
                                });
                            }
                            var value = {equipment: eqm,jobs: calendarDays};
                            commit('setEquipmentDailyCalendarJobs', {key, value});
                        }
                        else{
                            var key = eqm.id;
                            var calendarDays = {};
                            var value = {equipment: eqm,jobs: calendarDays};
                            commit('setEquipmentDailyCalendarJobs', {key, value});
                        }
                    });
                    
                    resolve(result);
                })
                .catch(error => reject(error));
        });
    },   
    clearEquipmentDailyItems({ commit } ) {
        commit('clearEquipmentDailyAll', null);
    },
    async getEquipmentWeeklyItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/runsheet-calendar/equipment`, { params: params })
                .then(response => {
                    var result = {};
                    var data = response.data.data;
                    result.equipments = data.equipmentItems;
                    result.equipmentTotal = data.equipmentTotal;
                    commit('setEquipmentWeeklyItems',result);                    
                    commit('clearEquipmentWeeklyCalendarJobs', null);
                    data.equipmentItems.forEach(function(eqm){
                        if(!Array.isArray(data.jobItems)){
                            var eqmDates = data.jobItems[eqm.id];
                            var key = eqm.id;
                            var calendarDays = {};
                            if(eqmDates){
                                Object.keys(eqmDates).forEach(function(key){
                                    var eqmDate = eqmDates[key];
                                    var isoWeek = eqmDate[0].weekdate;
                                    if(eqmDate.length == 1){
                                        calendarDays[isoWeek]={type: "Single",item:eqmDate[0]};
                                    }
                                    else{
                                        calendarDays[isoWeek]={type: "Overlap",item:eqmDate};
                                    }
                                });
                            }
                            var value = {equipment: eqm,jobs: calendarDays};
                            commit('setEquipmentWeeklyCalendarJobs', {key, value});
                        }
                        else{
                            var key = eqm.id;
                            var calendarDays = {};
                            var value = {equipment: eqm,jobs: calendarDays};
                            commit('setEquipmentWeeklyCalendarJobs', {key, value});
                        }
                    });
                    
                    resolve(result);
                })
                .catch(error => reject(error));
        });
    },   
    clearEquipmentWeeklyItems({ commit } ) {
        commit('clearEquipmentWeeklyAll', null);
    },
    async getEquipmentMonthlyItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/runsheet-calendar/equipment`, { params: params })
                .then(response => {
                    var result = {};
                    var data = response.data.data;
                    result.equipments = data.equipmentItems;
                    result.equipmentTotal = data.equipmentTotal;
                    commit('setEquipmentMonthlyItems',result);                    
                    commit('clearEquipmentMonthlyCalendarJobs', null);
                    data.equipmentItems.forEach(function(eqm){
                        if(!Array.isArray(data.jobItems)){
                            var eqmDates = data.jobItems[eqm.id];
                            var key = eqm.id;
                            var calendarDays = {};
                            if(eqmDates){
                                Object.keys(eqmDates).forEach(function(key){
                                    var eqmDate = eqmDates[key];
                                    var isoMonth = eqmDate[0].monthdate;
                                    if(eqmDate.length == 1){
                                        calendarDays[isoMonth]={type: "Single",item:eqmDate[0]};
                                    }
                                    else{
                                        calendarDays[isoMonth]={type: "Overlap",item:eqmDate};
                                    }
                                });
                            }
                            var value = {equipment: eqm,jobs: calendarDays};
                            commit('setEquipmentMonthlyCalendarJobs', {key, value});
                        }
                        else{
                            var key = eqm.id;
                            var calendarDays = {};
                            var value = {equipment: eqm,jobs: calendarDays};
                            commit('setEquipmentMonthlyCalendarJobs', {key, value});
                        }
                    });
                    
                    resolve(result);
                })
                .catch(error => reject(error));
        });
    },   
    clearEquipmentMonthlyItems({ commit } ) {
        commit('clearEquipmentMonthlyAll', null);
    },



    /* Property */
    async getPropertyDailyItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/runsheet-calendar/property`, { params: params })
                .then(response => {
                    var result = {};
                    var data = response.data.data;
                    result.properties = data.propertyItems;
                    result.propertiesTotal = data.propertyTotal;
                    commit('setPropertyDailyItems',result);                    
                    commit('clearPropertyDailyCalendarJobs', null);
                    data.propertyItems.forEach(function(prop){
                        if(!Array.isArray(data.jobItems)){
                            var propDates = data.jobItems[prop.property_id];
                            var key = prop.property_id;
                            var calendarDays = {};
                            if(propDates){
                                Object.keys(propDates).forEach(function(key) {
                                    var propDate = propDates[key];
                                    if(propDate.length == 1){
                                        calendarDays[propDate[0].planned_date]={type: "Single",item:propDate[0]};
                                    }
                                    else{
                                        calendarDays[propDate[0].planned_date]={type: "Overlap",item:propDate};
                                    }
                                });
                            }
                            var value = {property: prop,jobs: calendarDays};
                            commit('setPropertyDailyCalendarJobs', {key, value});
                        }
                        else{
                            var key = prop.property_id;
                            var calendarDays = {};
                            var value = {property: prop,jobs: calendarDays};
                            commit('setPropertyDailyCalendarJobs', {key, value});
                        }
                    });
                    
                    resolve(result);
                })
                .catch(error => reject(error));
        });
    },   
    clearPropertyDailyItems({ commit } ) {
        commit('clearPropertyDailyAll', null);
    },
    
    async getPropertyWeeklyItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/runsheet-calendar/property`, { params: params })
                .then(response => {
                    var result = {};
                    var data = response.data.data;
                    result.properties = data.propertyItems;
                    result.propertiesTotal = data.propertyTotal;
                    commit('setPropertyWeeklyItems',result);                    
                    commit('clearPropertyWeeklyCalendarJobs', null);
                    data.propertyItems.forEach(function(prop){
                        if(!Array.isArray(data.jobItems)){
                            var propDates = data.jobItems[prop.property_id];
                            var key = prop.property_id;
                            var calendarDays = {};
                            if(propDates){
                                Object.keys(propDates).forEach(function(key) {
                                    var propDate = propDates[key];
                                    var isoWeek = propDate[0].weekdate;
                                    if(propDate.length == 1){
                                        calendarDays[isoWeek]={type: "Single",item:propDate[0]};
                                    }
                                    else{
                                        calendarDays[isoWeek]={type: "Overlap",item:propDate};
                                    }
                                });
                            }
                            var value = {property: prop,jobs: calendarDays};
                            commit('setPropertyWeeklyCalendarJobs', {key, value});
                        }
                        else{
                            var key = prop.property_id;
                            var calendarDays = {};
                            var value = {property: prop,jobs: calendarDays};
                            commit('setPropertyWeeklyCalendarJobs', {key, value});
                        }
                    });
                    
                    resolve(result);
                })
                .catch(error => reject(error));
        });
    },  
    clearPropertyWeeklyItems({ commit } ) {
        commit('clearPropertyWeeklyAll', null);
    },

    
    async getPropertyMonthlyItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/runsheet-calendar/property`, { params: params })
                .then(response => {
                    var result = {};
                    var data = response.data.data;
                    result.properties = data.propertyItems;
                    result.propertiesTotal = data.propertyTotal;
                    commit('setPropertyMonthlyItems',result);                    
                    commit('clearPropertyMonthlyCalendarJobs', null);
                    data.propertyItems.forEach(function(prop){
                        if(!Array.isArray(data.jobItems)){
                            var propDates = data.jobItems[prop.property_id];
                            var key = prop.property_id;
                            var calendarDays = {};
                            if(propDates){
                                Object.keys(propDates).forEach(function(key) {
                                    var propDate = propDates[key];
                                    var isoMonth = propDate[0].monthdate;
                                    if(propDate.length == 1){
                                        calendarDays[isoMonth]={type: "Single",item:propDate[0]};
                                    }
                                    else{
                                        calendarDays[isoMonth]={type: "Overlap",item:propDate};
                                    }
                                });
                            }
                            var value = {property: prop,jobs: calendarDays};
                            commit('setPropertyMonthlyCalendarJobs', {key, value});
                        }
                        else{
                            var key = prop.property_id;
                            var calendarDays = {};
                            var value = {property: prop,jobs: calendarDays};
                            commit('setPropertyMonthlyCalendarJobs', {key, value});
                        }
                    });
                    
                    resolve(result);
                })
                .catch(error => reject(error));
        });
    },  
    clearPropertyMonthlyItems({ commit } ) {
        commit('clearPropertyMonthlyAll', null);
    },

    /* Selection */
    async setEquipmentStructureType({ commit }, params) {
        commit('setEquipmentStructureType',params);
    },
    async setLocationInfo({ commit }, params) {
        commit('setLocationInfo',params);
    },
    async setMaintProgram({ commit }, params) {
        commit('setMaintProgram',params);
    },
    async setYear({ commit }, params) {
        commit('setYear',params);
    },
}

const mutations = {
    /* Equipments Daily */
    setEquipmentDailyItems(state, data) {
        state.EquipmentDailyItems.equipments = data.equipments;
        state.EquipmentDailyItems.equipmentTotal = data.equipmentTotal;
    },
    setEquipmentDailyCalendarJobs(state, data){
        Vue.set(state.EquipmentDailyItems.calendarJobs,data.key,data.value);
    },
    clearEquipmentDailyCalendarJobs(state, data){
        state.EquipmentDailyItems.calendarJobs = {};
    },
    clearEquipmentDailyAll(state, data){
        state.EquipmentDailyItems = {
            equipments: [],
            calendarJobs: {},
            equipmentTotal: 0
        };
    },

    
    /* Equipments Weekly */
    setEquipmentWeeklyItems(state, data) {
        state.EquipmentWeeklyItems.equipments = data.equipments;
        state.EquipmentWeeklyItems.equipmentTotal = data.equipmentTotal;
    },
    setEquipmentWeeklyCalendarJobs(state, data){
        Vue.set(state.EquipmentWeeklyItems.calendarJobs,data.key,data.value);
    },
    clearEquipmentWeeklyCalendarJobs(state, data){
        state.EquipmentWeeklyItems.calendarJobs = {};
    },
    clearEquipmentWeeklyAll(state, data){
        state.EquipmentWeeklyItems = {
            equipments: [],
            calendarJobs: {},
            equipmentTotal: 0
        };
    },

    
    /* Equipments Monthly */
    setEquipmentMonthlyItems(state, data) {
        state.EquipmentMonthlyItems.equipments = data.equipments;
        state.EquipmentMonthlyItems.equipmentTotal = data.equipmentTotal;
    },
    setEquipmentMonthlyCalendarJobs(state, data){
        Vue.set(state.EquipmentMonthlyItems.calendarJobs,data.key,data.value);
    },
    clearEquipmentMonthlyCalendarJobs(state, data){
        state.EquipmentMonthlyItems.calendarJobs = {};
    },
    clearEquipmentMonthlyAll(state, data){
        state.EquipmentMonthlyItems = {
            equipments: [],
            calendarJobs: {},
            equipmentTotal: 0
        };
    },

    /* Properties Daily */
    setPropertyDailyItems(state, data) {
        state.PropertyDailyItems.properties = data.properties;
        state.PropertyDailyItems.propertiesTotal = data.propertiesTotal;
    },
    setPropertyDailyCalendarJobs(state, data){
        Vue.set(state.PropertyDailyItems.calendarJobs,data.key,data.value);
    },
    clearPropertyDailyCalendarJobs(state, data){
        state.PropertyDailyItems.calendarJobs = {};
    },
    clearPropertyDailyAll(state, data){
        state.PropertyDailyItems = {
            properties: [],
            calendarJobs: {},
            propertiesTotal: 0
        };
    },

    
    /* Properties Weekly */
    setPropertyWeeklyItems(state, data) {
        state.PropertyWeeklyItems.properties = data.properties;
        state.PropertyWeeklyItems.propertiesTotal = data.propertiesTotal;
    },
    setPropertyWeeklyCalendarJobs(state, data){
        Vue.set(state.PropertyWeeklyItems.calendarJobs,data.key,data.value);
    },
    clearPropertyWeeklyCalendarJobs(state, data){
        state.PropertyWeeklyItems.calendarJobs = {};
    },
    clearPropertyWeeklyAll(state, data){
        state.PropertyWeeklyItems = {
            properties: [],
            calendarJobs: {},
            propertiesTotal: 0
        };
    },

    
    /* Properties Monthly */
    setPropertyMonthlyItems(state, data) {
        state.PropertyMonthlyItems.properties = data.properties;
        state.PropertyMonthlyItems.propertiesTotal = data.propertiesTotal;
    },
    setPropertyMonthlyCalendarJobs(state, data){
        Vue.set(state.PropertyMonthlyItems.calendarJobs,data.key,data.value);
    },
    clearPropertyMonthlyCalendarJobs(state, data){
        state.PropertyMonthlyItems.calendarJobs = {};
    },
    clearPropertyMonthlyAll(state, data){
        state.PropertyMonthlyItems = {
            properties: [],
            calendarJobs: {},
            propertiesTotal: 0
        };
    },

    /* Selection */
    setEquipmentStructureType(state, data) {
        state.equipmentStructureType = data;
    },
    setLocationInfo(state, data) {
        state.locationInfo = data;
    },
    setMaintProgram(state, data) {
        state.maintProgram = data;
    },
    setYear(state, data) {
        state.year = data;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}